sap.ui.requireSync("sap/ui/integration/customElements/CustomElementEditor");
